import React, { useEffect, useState } from "react";
import { IoArrowBack } from "react-icons/io5";
import {
    GET_CONSUMER_PAYMENTS_ENDPOINT,
    GET_CONSUMER_RECEIPTS_ENDPOINT,
    GET_CONSUMER_VIRTUAL_ACCOUNT_DETAILS_ENDPOINT,
    TIMELINE,
} from "../../../constants/routes";
import useNetwork from "../../../hooks/useNetwork";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import cn from "../../../lib/cn";
import Container from "../../../shared/Container";
import Section from "../../../shared/Section";
import { buttonBaseStyles } from "../../../shared/ui/Button";
import Stepper from "../../../shared/ui/Stepper";
import Confirmation from "./confirmation";
import Payment from "./payment";
import Summary from "./summary";

import { useHistory } from "react-router-dom";
import { MODE } from "../../../constants/common";

let steps = ["Summary", "Payment", "Confirmation"];

const BookNow = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const { width } = useWindowDimensions();
    const [paymentMode, setPaymentMode] = useState(MODE.upi);
    const { data } = useNetwork(GET_CONSUMER_RECEIPTS_ENDPOINT);

    const { data: virtualAccount } = useNetwork(
        GET_CONSUMER_VIRTUAL_ACCOUNT_DETAILS_ENDPOINT
    );

    const { data: historyData } = useNetwork(GET_CONSUMER_PAYMENTS_ENDPOINT);

    const [selectedPayment, setSelectedPayment] = useState(null);

    useEffect(() => {
        if (data) {
            let selectable = data?.data?.data.find(
                (element) => element?.status !== "PAID"
            );
            setSelectedPayment(selectable);
        }
    }, [data]);

    const history = useHistory();

    return (
        <Section className=" !mb-0 bg-white min-h-screen !pb-0">
            <div className="bg-primary pt-8 xl:pt-10.4 lg:bg-transparent pb-2">
                <Container className="px-0 lg:px-2">
                    <div className="flex h-full">
                        <div className="hidden lg:block">
                            <button
                                className={cn(
                                    buttonBaseStyles,
                                    "flex items-center gap-0.5"
                                )}
                                onClick={() => history.push(TIMELINE)}
                            >
                                <IoArrowBack />
                                Go Back
                            </button>
                        </div>
                        <div className="flex-1 flex flex-col items-center h-full">
                            <div className="w-[80%] lg:w-3/6 my-2.4">
                                <Stepper
                                    steps={steps}
                                    currentStep={currentStep}
                                    onClick={(e) => setCurrentStep(e)}
                                    theme={width < 1024 ? "dark" : "light"}
                                    showCurrentStep={false}
                                />
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
            <div className="rounded-t-4 -mt-4 bg-white pb-7 ">
                <Container>
                    {data && (
                        <div className="flex justify-center">
                            (
                            <div className="w-full  xl:w-5/6  bg-white px-0 lg:p-0 py-2 rounded-t-2.5 lg:rounded-t-none lg:bg-transparent h-full ">
                                {currentStep === 1 ? (
                                    <Summary
                                        onClick={() => setCurrentStep(2)}
                                    />
                                ) : currentStep === 2 ? (
                                    <Payment
                                        onClick={() => setCurrentStep(3)}
                                        receipts={data?.data?.data || []}
                                        selected={selectedPayment}
                                        virtualAccount={
                                            virtualAccount?.data?.data
                                        }
                                        paymentMode={paymentMode}
                                        setPaymentMode={setPaymentMode}
                                    />
                                ) : (
                                    <Confirmation
                                        history={
                                            historyData?.data?.data?.payments ||
                                            []
                                        }
                                        data={selectedPayment}
                                        paymentMode={paymentMode}
                                    />
                                )}
                            </div>
                            )
                        </div>
                    )}
                </Container>
            </div>
        </Section>
    );
};

export default BookNow;
